import { render, staticRenderFns } from "./dredgeVip.vue?vue&type=template&id=7cd7ae2a&scoped=true&"
import script from "./dredgeVip.vue?vue&type=script&lang=js&"
export * from "./dredgeVip.vue?vue&type=script&lang=js&"
import style0 from "./dredgeVip.vue?vue&type=style&index=0&id=7cd7ae2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd7ae2a",
  null
  
)

export default component.exports